import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  const navLinksLeft = [{
    label: "Experience",
    href: "/#experience"
  }, {
    label: "Restaurants",
    href: "/#restaurants"
  }];
  const navLinksRight = [{
    label: "Impact",
    href: "/#impact"
  }, {
    label: "Gallery",
    href: "/#gallery"
  }, {
    label: "Sponsors",
    href: "/#sponsors"
  }];
  const allLinks = [...navLinksLeft, ...navLinksRight];
  return <header id="header" className={cn("fixed top-0 left-0 w-full z-50 transition-all duration-300 border-b border-transparent dark bg-background text-foreground", isScrolled ? "bg-background/70 backdrop-blur-lg shadow-lg border-white/10 py-2" : "bg-background py-4")}>
      <div className="container mx-auto px-4 md:px-8 relative flex items-center justify-between h-16">
        {}
        <div className="lg:hidden z-20">
          <Button variant="ghost" size="icon" className="text-foreground hover:bg-white/10" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
            {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
          </Button>
        </div>

        {}
        <nav className="hidden lg:flex flex-1 justify-end items-center gap-8 pr-12">
          {navLinksLeft.map((link, i) => <Link key={i} to={link.href} className="text-sm font-sans font-medium uppercase tracking-widest text-primary hover:text-white transition-colors" data-index={i}>
              {link.label}
            </Link>)}
        </nav>

        {}
        <div className="flex-shrink-0 flex justify-center items-center z-10 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 lg:static lg:translate-x-0 lg:translate-y-0">
          <Link to="/#">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/sabor_denver_logo_header.png" alt="Sabor Denver" className="h-7 w-auto object-contain" />
          </Link>
        </div>

        {}
        <nav className="hidden lg:flex flex-1 justify-start items-center gap-8 pl-12">
          {navLinksRight.map((link, i) => <Link key={i} to={link.href} className="text-sm font-sans font-medium uppercase tracking-widest text-primary hover:text-white transition-colors" data-index={i}>
              {link.label}
            </Link>)}
        </nav>

        {}
        <div className={cn("hidden lg:block absolute right-0 transition-all duration-500", isScrolled ? "opacity-100 translate-x-0 pointer-events-auto" : "opacity-0 translate-x-4 pointer-events-none")}>
          <Button asChild size="sm" className="bg-primary text-primary-foreground hover:bg-primary/90 font-sans font-bold uppercase tracking-wide text-xs px-6">
            <Link to="/#tickets">Buy Tickets</Link>
          </Button>
        </div>
      </div>

      {}
      <div className={cn("absolute top-full left-0 w-full bg-background/95 backdrop-blur-xl border-b border-white/10 transition-all duration-300 ease-in-out lg:hidden overflow-hidden flex flex-col items-center", isMobileMenuOpen ? "max-h-screen py-8 opacity-100 shadow-xl" : "max-h-0 py-0 opacity-0")}>
        <nav className="flex flex-col items-center gap-6 px-4 w-full">
          {allLinks.map((link, i) => <Link key={i} to={link.href} className="text-lg font-sans font-medium uppercase tracking-widest text-primary hover:text-white transition-colors" data-index={i} onClick={() => setIsMobileMenuOpen(false)}>
              {link.label}
            </Link>)}
          <Button asChild className="mt-4 bg-primary text-primary-foreground hover:bg-primary/90 font-sans font-bold uppercase tracking-wide w-full max-w-xs">
            <Link to="/#tickets" onClick={() => setIsMobileMenuOpen(false)}>
              Buy Tickets
            </Link>
          </Button>
        </nav>
      </div>
    </header>;
}